// extracted by mini-css-extract-plugin
export default {"attribute-text":"attribute-text_ZHu2Dudq","attribute-dagger":"attribute-dagger_EBvzFu0Y"};